import { render } from "./AvailableDevelopers.vue?vue&type=template&id=5fe2b710"
import script from "./AvailableDevelopers.vue?vue&type=script&lang=js"
export * from "./AvailableDevelopers.vue?vue&type=script&lang=js"

import "./AvailableDevelopers.vue?vue&type=style&index=0&id=5fe2b710&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__